import { ComponentType, FC, ReactNode } from "react";

interface IconLabelProps {
  icon?: ComponentType<{ className?: string }>;
  label: ReactNode;
}

export const IconLabel: FC<IconLabelProps> = ({ icon: Icon, label }) => {
  return (
    <div className="flex flex-row items-center overflow-hidden truncate text-ellipsis whitespace-nowrap">
      {Icon && (
        <div className="mr-2 h-3 w-3">
          <Icon className="h-3 w-3" />
        </div>
      )}
      <span className="overflow-hidden text-ellipsis whitespace-nowrap">{label}</span>
    </div>
  );
};
